// Reglas de contraseña comunes a la web y al juego. La contraseña de la web es también la
// del juego: el cliente 3.3.5 solo deja escribir 16 caracteres y no reconoce ñ, tildes ni
// espacios. Misma regla en backend/deps.py (validate_game_password).
export const PASSWORD_MIN_LEN = 8;
export const PASSWORD_MAX_LEN = 16;
const ALLOWED = /^[!-~]+$/; // ASCII imprimible sin espacio

export const PASSWORD_HINT = `Entre ${PASSWORD_MIN_LEN} y ${PASSWORD_MAX_LEN} caracteres: letras sin tilde, números y símbolos`;

// Devuelve el mensaje de error, o '' si vale.
export function validateGamePassword(password) {
  if (password.length < PASSWORD_MIN_LEN || password.length > PASSWORD_MAX_LEN) {
    return `La contraseña debe tener entre ${PASSWORD_MIN_LEN} y ${PASSWORD_MAX_LEN} caracteres.`;
  }
  if (!ALLOWED.test(password)) {
    return 'La contraseña solo puede llevar letras sin tilde, números y símbolos (sin espacios, ñ ni acentos).';
  }
  return '';
}
